import {
  SET_OPENED_MODAL,
  CHANGE_HEADER_TYPE,
  CHANGE_CONDITION_SHOWN,
  SET_OPENED_MODAL_START,
} from "./consts";

export const setOpenedModal = (text) => {
  return {
    type: SET_OPENED_MODAL,
    payload: text,
  };
};

export const setOpenedModalStart = (text) => {
  return {
    type: SET_OPENED_MODAL_START,
    payload: text,
  };
};

export const changeHeaderType = (type) => {
  return {
    type: CHANGE_HEADER_TYPE,
    payload: type,
  };
};

export const changeConditionShown = (type) => {
  return {
    type: CHANGE_CONDITION_SHOWN,
    payload: type,
  };
};
